import { BasicComponent, ComponentChild, ComponentChildren } from "haxt";

import "./GridGallery.scss";

/*
[
	"/image/gallery/Avoca_BallymurtaghMine.png",
	"/image/gallery/Blackstairs Mountain.png",
	"/image/gallery/Cut Bog.jpg",
	"/image/gallery/Devils Matchstick Lichen.png",
	"/image/gallery/PXL_20240826_101236903.MP.jpg",
	"/image/gallery/PXL_20240826_115630027.jpg",
	"/image/gallery/Round-Level Sundew.png",
	"/image/gallery/TinyFrog2.jpg"
]
*/

export namespace GridGallery {
	export type Options = {
	};
	export type Props = {
		class?: JSX.HTMLAttributes["class"];
		style?: JSX.HTMLAttributes["style"];
		options: GridGallery.Options;
		// [BasicComponent.Children]?: ComponentChildren;
		items: string[];
	};
}
export class GridGallery extends BasicComponent<GridGallery.Props> {
	protected override receivedProps(props: any, children: ComponentChild[]): void {
		super.receivedProps(props, children);
		// schedule an update to render with new props
		// TODO: better handling?
		this.update();
	}

	get cls() {
		return BasicComponent.mergeClasses(
			{
				GridGallery: true
			},
			this.props.class
		);
	}

	public render() {
		return (
			<div class={this.cls} style={this.props.style}>
				<div class="container">
					{this.props.items.map((src) => {
						return <div><img src={src} /></div>;
					})}
				</div>
			</div>
		);
	}
}
